import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import _ from 'lodash';
import classnames from 'classnames/bind';
import actions from '../../../redux/actions';
import {
  IModal,
  IOilFilter,
  IState,
  IVehicle,
  Replacement,
} from '../../../interface';
import {ModalHref} from '../../../interface/emnu';
import style from './index.module.scss';
import localesReplacement from '../../../utils/localesReplacement';

const cx = classnames.bind(style);

export interface Props extends IOilFilter {
  vehicle: IVehicle | undefined;
  replacements: Replacement;
  setModal: (value: IModal) => void;
  setVehicle: (value: IVehicle | undefined) => void;
  disabled: boolean;
}

//Vehicle dropdown component
export const VehicleSelection = (props: Props) => {
  const {setModal, replacements, vehicle, setVehicle, disabled} = props;
  const remove = () => {
    setVehicle(undefined);
  };
  const wtbGTA=()=>{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'wtbButtonVehicleSearch',
      languageCode:localStorage.getItem("languageCode"),
      countryCode:localStorage.getItem('countryCode')
    });
    !disabled && setModal({visibie: true, href: ModalHref.FindTheRightOil});
  }
  return (
    <div className={cx('vehicle-selection', 'selected', {'disabled': disabled})}>
      <div className={cx('dropdown')}>
        <strong>{localesReplacement(replacements, 'Vehicle')}</strong>
        <div className={cx('input-with-close')}>
          <span
            className={`overflowText ${cx('selected')}`}
            onClick={wtbGTA}
          >
            {_.isUndefined(vehicle) ||
            _.chain(vehicle).values().compact().isEmpty().value()
              ? localesReplacement(replacements, 'Find your vehicle')
              : `${vehicle['make']} ${vehicle['model']}`}
          </span>
          {!_.chain(vehicle).values().compact().isEmpty().value() && (
            <span
              className={`button ${cx('remove-button')}`}
              onClick={remove}
              role='button'
            ></span>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
  vehicle: state.filter.vehicle,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setModal: (value: IModal) => dispatch(actions.setModal(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VehicleSelection);
